import { Formik } from 'formik';
import { validationSchemaAccount, initialValuesAccount } from './CreateAccountValidator';
import Form from "./CreateAccount";
import { useAxios } from '../../../../context/AxiosHookContext';
import { useNotification } from '../../../../context/NotificationContext';

const FormCreateAccount = ({ valuesToEdit, onClose, getValues }) => {

    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const handleSubmit = async (checkbookAccount) => {

        try {

            if (checkbookAccount._id) {
                await axios.put(`/checkbook/checkbookAccount/${checkbookAccount._id}`, checkbookAccount)
            }  else {
                await axios.post(`/checkbook/checkbookAccount`, checkbookAccount)
            }

            showSnackbar({ severity: "success", title: "Cuenta de banco", message: "Se ha guardado de forma exitosa." });

            getValues();

        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Ha ocurrido un error al crear."
            showSnackbar({ severity: "error", title: "Cuenta de banco", message })
        }
    }

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initialValuesAccount
    }
    return (
        <Formik
            validationSchema={validationSchemaAccount}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
        >
            <>
                <Form onClose={onClose} />
            </>
        </Formik>
    )
}

export { FormCreateAccount }